import { Stack } from '@mui/material';
import { LinkOrMenu } from '../../../utils/layout';
import { Container } from '../../layouts/Container';
import { HeaderLinksMobile } from './HeaderLinksMobile';
import { HeaderActionButtons } from './HeaderActionButtons';

type MainBurgerMenuProps = {
  headerLinks: LinkOrMenu[];
  onMenuClose: () => void;
};

export const MainBurgerMenu = ({ headerLinks, onMenuClose }: MainBurgerMenuProps) => {
  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100%'
      }}
    >
      {/* Links */}
      <Stack sx={{
        width: '100%',
        maxWidth: '18rem',
        justifyContent:
        'space-between',
        height: '100%',
        mt: '1rem'
      }}>
        <HeaderLinksMobile links={headerLinks} onClick={onMenuClose} />
        <HeaderActionButtons onClick={onMenuClose} />
      </Stack>
    </Container>
  );
};
